var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.525 9.35L9.025 0.5L14.525 9.35H3.525ZM14.65 20.5C13.4167 20.5 12.3833 20.0833 11.55 19.25C10.7167 18.4167 10.3 17.3833 10.3 16.15C10.3 14.9167 10.7167 13.8833 11.55 13.05C12.3833 12.2167 13.4167 11.8 14.65 11.8C15.8833 11.8 16.9167 12.2167 17.75 13.05C18.5833 13.8833 19 14.9167 19 16.15C19 17.3833 18.5833 18.4167 17.75 19.25C16.9167 20.0833 15.8833 20.5 14.65 20.5ZM0 19.875V12.275H7.6V19.875H0ZM14.65 19C15.45 19 16.125 18.725 16.675 18.175C17.225 17.625 17.5 16.95 17.5 16.15C17.5 15.35 17.225 14.675 16.675 14.125C16.125 13.575 15.45 13.3 14.65 13.3C13.85 13.3 13.175 13.575 12.625 14.125C12.075 14.675 11.8 15.35 11.8 16.15C11.8 16.95 12.075 17.625 12.625 18.175C13.175 18.725 13.85 19 14.65 19ZM1.5 18.375H6.1V13.775H1.5V18.375ZM6.225 7.85H11.825L9.025 3.325L6.225 7.85Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypes);
export default __webpack_public_path__ + "static/media/Types.52824828a83d3754efc39f44e77e1b9f.svg";
export { ForwardRef as ReactComponent };